// Tracks browser connectivity for the offline UX (offline bar, map fallback
// notice, etc). SSR-safe: the server has no concept of "online", so it always
// reports true there and the client reconciles on mount via navigator.onLine
// + the online/offline window events.
export const useOnlineStatus = () => {
    if (import.meta.server) {
        return { isOnline: ref(true) };
    }

    const isOnline = useState('online-status', () => true);

    const setOnline = () => {
        isOnline.value = true;
    };

    const setOffline = () => {
        isOnline.value = false;
    };

    onMounted(() => {
        isOnline.value = navigator.onLine;
        window.addEventListener('online', setOnline);
        window.addEventListener('offline', setOffline);
    });

    onUnmounted(() => {
        window.removeEventListener('online', setOnline);
        window.removeEventListener('offline', setOffline);
    });

    return { isOnline };
};
